import FrontPage from "../components/FrontPage";
import Logo from "../components/Logo";
import { useIsMobile } from "./Flexbox";

const SessionScreen = ({children, theme, isDark}) => {
    const isMobile = useIsMobile();

    return(
        <div style={{minHeight: '100dvh', width: '100%', background: 'rgba(255, 255, 255, 1)', display: 'flex', zIndex: 1000}}>
            <div style={{display: 'flex', flexDirection: 'column',  flexShrink: 0, justifyContent: 'center',alignItems: 'flex-start', paddingLeft: 120, paddingRight: 40, backgroundColor: theme.Alfalfa, ...(isMobile ? {width: '100%', paddingLeft: 24, paddingRight: 24} : {})}}>
                <div style={{display: 'flex', flexDirection: 'row', width:331, justifyContent: 'flex-start', marginBottom: 50, ...(isMobile ? {width: '100%'} : {})}}>
                    <Logo height={106} width={106}/>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', width: 331, gap: 32, paddingTop: 40, paddingBottom: 40, ...(isMobile ? {width: '100%'} : {})}}>
                    {children}
                </div>
            </div>
            {!isMobile && (
                <div style={{flex: 1, minHeight: '100dvh', display: 'flex',  flexDirection: 'column', position: 'relative', overflow: 'hidden', filter: isDark ? 'brightness(.8)' : 'brightness(1)'}}>
                    <FrontPage height="100%" width="100%"/>
                </div>
            )}
        </div>
    )
}

export default SessionScreen;